export default __webpack_public_path__ + "static/media/linkedin-icon.29d467c1.svg";